import React from "react";
import { bind } from "decko";
import { Modal } from "react-bootstrap";

import Util from "./include/Util";

export default class EditThumbnail extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            show: false
        };
    }

    @bind
    showSelection () {
        this.setState({show: true});
    }

    @bind
    hideSelection () {
        this.setState({show: false});
    }

    @bind
    onChangeSelection (url) {
        this.setState({show: false});
        this.props.onChange(url);
    }

    renderModal () {
        const maxSetSize = 50;
        const duration = this.props.toTimestamp - this.props.fromTimestamp;
        const stepSize = Math.max(1000, duration / maxSetSize);
        const maxTimestamp = this.props.toTimestamp - stepSize;

        let options = [];
        for (let i=this.props.fromTimestamp; i<=maxTimestamp; i+=stepSize) {
            let url = Util.getThumbnailUrl(this.props.videoAssetName, i);
            options.push(
                <img
                    key={url}
                    src={url}
                    className={url === this.props.selected ? "active" : ""}
                    onClick={() => this.onChangeSelection(url)}
                />
            );
        }

        return (
            <Modal
                show
                dialogClassName="thumbnail-modal"
                onHide={this.hideSelection}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Select a thumbnail
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-xs-12">
                            {options}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    render () {

        let modal = null;
        if (this.state.show) {
            modal = this.renderModal();
        }

        return (
            <div className="row">
                <img onClick={this.showSelection} className="selected-thumb" src={this.props.selected} />
                <div className="text-center text-outline fullwidth" style={{
                    position: "absolute",
                    bottom: "2px",
                    pointerEvents: "none",
                }}>
                    Tap to change
                </div>
                {modal}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/EditThumbnail.js